import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export type SwrError = {
  status: number | null
  info: { message: string } | null
  endpoint: string
  timestamp: number
}

type State = {
  error: SwrError | null
  errorHistory: SwrError[]
}

type Actions = {
  setError: (_error: SwrError) => void
  clearErrors: () => void
}

const useSWRStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      error: null,
      errorHistory: [],
      setError: ({ status, info, endpoint }) =>
        set((state) => {
          state.error = { status, info, endpoint, timestamp: Date.now() }
          state.errorHistory = [
            ...state.errorHistory.slice(-9),
            { status, info, endpoint, timestamp: Date.now() }
          ]
        }),
      clearErrors: () => set({ error: null, errorHistory: [] })
    }))
  )
)

export { useSWRStore }
